"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.addUserWhatsNew = exports.getLatestWhatsNew = exports.createWhatsNew = exports.deleteWhatsNew = exports.getSingleWhatsNew = exports.getWhatsNewList = exports.resetWhatsNew = exports.setEditableWhatsNew = exports.togglePreview = exports.toggleDetailsModal = exports.toggleAddModal = exports.setDeletedStatus = exports.updateWhatsNewList = exports.setSingleWhatsNew = exports.whatsNewList = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const api_1 = require("../../services/api");
const api_2 = require("../../services/api");
const initialState = {
    singleWhatsNew: {
        title: '',
        subtitle: { 0: '' },
        deleted: false
    },
    list: [],
    count: 0,
    limit: 50,
    addModalOpen: false,
    detailsModalOpen: false,
    preview: false,
    editable: {
        title: '',
        subtitle: { 0: '' }
    }
};
const whatsNewSlice = toolkit_1.createSlice({
    name: 'whatsNew',
    initialState: initialState,
    reducers: {
        whatsNewList: (state, action) => {
            state.list = action.payload.list;
            state.count = action.payload.count || 0;
            return state;
        },
        setSingleWhatsNew: (state, action) => {
            state.singleWhatsNew = action.payload;
            return state;
        },
        setEditableWhatsNew: (state, action) => {
            state.editable = Object.assign(Object.assign({}, state.editable), action.payload);
            return state;
        },
        updateWhatsNewList: (state, action) => {
            state.list.unshift(action.payload);
            return state;
        },
        setDeletedStatus: (state, action) => {
            const whatsNewIndex = state.list.findIndex(e => e.id === action.payload.id);
            if (whatsNewIndex > -1) {
                state.list[whatsNewIndex] = Object.assign(Object.assign({}, state.list[whatsNewIndex]), { deleted: true });
            }
            return state;
        },
        toggleAddModal: (state) => {
            state.addModalOpen = !state.addModalOpen;
            return state;
        },
        toggleDetailsModal: (state) => {
            state.detailsModalOpen = !state.detailsModalOpen;
            return state;
        },
        togglePreview: (state) => {
            state.preview = !state.preview;
            return state;
        },
        resetWhatsNew: (state) => {
            state.editable = initialState.editable;
            state.preview = initialState.preview;
            state.addModalOpen = initialState.addModalOpen;
            state.detailsModalOpen = initialState.detailsModalOpen;
            state.singleWhatsNew = initialState.singleWhatsNew;
            return state;
        },
    }
});
_a = whatsNewSlice.actions, exports.whatsNewList = _a.whatsNewList, exports.setSingleWhatsNew = _a.setSingleWhatsNew, exports.updateWhatsNewList = _a.updateWhatsNewList, exports.setDeletedStatus = _a.setDeletedStatus, exports.toggleAddModal = _a.toggleAddModal, exports.toggleDetailsModal = _a.toggleDetailsModal, exports.togglePreview = _a.togglePreview, exports.setEditableWhatsNew = _a.setEditableWhatsNew, exports.resetWhatsNew = _a.resetWhatsNew;
const getWhatsNewList = (data) => async (dispatch) => {
    try {
        const payload = await api_1.Admin.whatsNewList(data);
        dispatch(exports.whatsNewList(payload));
    }
    catch (e) {
        return false;
    }
};
exports.getWhatsNewList = getWhatsNewList;
const getSingleWhatsNew = (id) => async (dispatch) => {
    try {
        const singleWhatsNew = await api_1.Admin.getSingleWhatsNew(id);
        dispatch(exports.setSingleWhatsNew(singleWhatsNew));
    }
    catch (e) {
        return false;
    }
};
exports.getSingleWhatsNew = getSingleWhatsNew;
const deleteWhatsNew = (id) => async (dispatch) => {
    try {
        await api_1.Admin.deleteWhatsNew(id);
        dispatch(exports.setDeletedStatus({ id }));
    }
    catch (e) {
        return false;
    }
};
exports.deleteWhatsNew = deleteWhatsNew;
const createWhatsNew = (data) => async (dispatch) => {
    try {
        await api_1.Admin.createWhatsNew(data);
        dispatch(exports.getWhatsNewList({}));
    }
    catch (e) {
        return false;
    }
};
exports.createWhatsNew = createWhatsNew;
const getLatestWhatsNew = () => async (dispatch) => {
    try {
        const latest = await api_2.WhatsNew.getLatestWhatsNew();
        dispatch(exports.setSingleWhatsNew(latest));
    }
    catch (e) {
        return false;
    }
};
exports.getLatestWhatsNew = getLatestWhatsNew;
const addUserWhatsNew = (data) => async (dispatch) => {
    try {
        await api_2.WhatsNew.addUserWhatsNew(data);
    }
    catch (e) {
        console.log(e);
    }
};
exports.addUserWhatsNew = addUserWhatsNew;
/*
export const editWhatsNew = (data) => async dispatch => {
    try {
        const edited = await Admin.editWhatsNew(data);
        dispatch(updateWhatsNewList(edited));
    } catch (e) {
        console.log(e);
    }
};
*/
exports.default = whatsNewSlice.reducer;
